export const DEAL_SIGNAL_TEMPLATE_URL =
    "https://sales-workspace-staging.s3.us-east-1.amazonaws.com/SignalsEnrichment/deal_signal_template.csv";

export const DEAL_SIGNAL_CSV_HEADERS = ["company_name/domain", "closedate", "iswon"] as const;

/** Static sample shown under "Required columns" to illustrate the expected file shape. */
export const DEAL_SIGNAL_CSV_EXAMPLE_ROWS = [
    ["stripe.com", "2026-01-15", "TRUE"],
    ["Notion", "2026-02-02", "TRUE"],
] as const;

/** Enforced client-side so an oversized file is rejected before upload, not after. */
export const DEAL_SIGNAL_MAX_COMPANIES = 2000;

/**
 * Display copy only. The weekly limit is enforced by the backend, which reports its verdict as
 * `nextUploadAllowedAt` — change the period there and this number has to be changed to match.
 */
export const DEAL_SIGNAL_UPLOAD_COOLDOWN_DAYS = 7;

/** Shared by the file rows and the upload-cooldown tooltip so the two dates cannot drift apart. */
export const DEAL_SIGNAL_DATE_FORMAT = "DD.MM.YYYY";

export const SIGNAL_RECOMMENDER_FILES_PAGE_SIZE = 10;

export const DEAL_SIGNAL_POLL_INTERVAL_MS = 5000;

/** A stalled run usually refetches unchanged, so the spinner is held long enough to be seen. */
export const DEAL_SIGNAL_REFRESH_MIN_SPINNER_MS = 500;

/**
 * How long a run may sit in progress before the page stops polling it and calls it stalled.
 *
 * The backend reports no failure for an abandoned job, so without a ceiling the list polls every five
 * seconds for as long as the tab stays open and the row never resolves.
 *
 * Measured against the *latest* instant `created` can stand for, so a run recorded today — which the
 * list endpoint dates without a time of day — is never stalled on the strength of a date alone.
 */
export const DEAL_SIGNAL_MAX_PROCESSING_MS = 2 * 60 * 1000;

/**
 * Id of the placeholder row shown while an upload is in flight. Negative so it cannot collide with a
 * real enrichment id, which also makes it obvious in a cache dump that the row is not the server's.
 */
export const OPTIMISTIC_DEAL_SIGNAL_ID = -1;
